document.addEventListener("DOMContentLoaded", function () {

  function filterImagesByColor(color) {
    if (!color) return;

    document.querySelectorAll("li[data-mediaalt]").forEach(function (item) {
      var mediaAlt = item.getAttribute("data-mediaalt");

      if (mediaAlt && mediaAlt.toLowerCase() === color.toLowerCase()) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  /* 🔹 CLICK par (tumhara existing code extended) */
  document.querySelectorAll(".ctm_swatches").forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      var swatchValue = this.getAttribute("data-swatch");
      filterImagesByColor(swatchValue);
    });
  });

  /* 🔹 PAGE LOAD par (checked variant se) */
  var checkedInput = document.querySelector(
    '.ctm_swatches input[type="radio"]:checked'
  );

  if (checkedInput) {
    var parentSwatch = checkedInput.closest(".ctm_swatches");
    var defaultColor = parentSwatch.getAttribute("data-swatch");
    filterImagesByColor(defaultColor);
  }

});